
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb = {
    BASE_URL: "https://js-practice-one-json-server.vercel.app",
    PRODUCTS_ENDPOINT: "products",
    CART_ENDPOINT: "cart"
};


const $b0227b060345e8b7$var$MESSAGES = {
    PRODUCT_EMPTY_MSG: "The product is running out of stock",
    ADD_CART_SUCCESS_MSG: "The item is added to your cart!",
    ADD_CART_FAILED_MSG: "This item can't be added right now!",
    ADD_PRODUCT_SUCCESS_MSG: "Successfully added the product!",
    ADD_PRODUCT_FAILED_MSG: "Failed to add the product!",
    UPDATE_ITEM_SUCCESS_MSG: "Successfully updated the product!",
    UPDATE_ITEM_FAILED_MSG: "The item cannot be updated right now!",
    INCREMENT_CART_FAILED_MSG: "You cannot add more items!",
    INCREMENT_CART_SUCCESS_MSG: "You've bought one more of this item!",
    DELETE_CART_SUCCESS_MSG: "The item is deleted!",
    DELETE_CART_FAILED_MSG: "This item can't be deleted right now!",
    DELETE_PRODUCT_SUCCESS_MSG: "Successfully deleted the product!",
    DELETE_PRODUCT_FAILED_MSG: "Failed to delete the product!",
    DELETE_CONFIRMATION_MSG: "Are you sure that you want to delete this item?",
    ADD_PRODUCT_HEADING: "Add Product Page",
    EDIT_PRODUCT_HEADING: "Edit Product Page",
    EMPTY_CART_HEADING: "Your cart is empty.",
    EMPTY_PRODUCT_LIST_HEADING: "No products here yet."
};
var $b0227b060345e8b7$export$2e2bcd8739ae039 = $b0227b060345e8b7$var$MESSAGES;


/**
 * Creates an HTML element with the specified tag, class name, text content, and attributes.
 * @param {string} tag - The tag name for the element
 * @param {string} [className=''] - The class name for the element
 * @param {string} [textContent=''] - The text content for the element
 * @param {Object} [attributes={}] - An object containing any additional attributes for the element
 * @returns {HTMLElement} The created HTML element
 */ function $67c86a85254b66ad$export$ad87ea24ece11d1d({ tag: tag, className: className = "", textContent: textContent = "", attributes: attributes = {} }) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (textContent) element.textContent = textContent;
    for(let attr in attributes)element.setAttribute(attr, attributes[attr]);
    return element;
}
/**
 * Gets an HTML element by its ID
 * @param {string} id - The ID of the HTML element
 * @returns {Element} The HTML element with the specified ID
 */ function $67c86a85254b66ad$export$83595b84fc78b9b4(element = document, id) {
    return element.getElementById(id);
}
/**
 * Gets a value of an element by its ID
 * @param {string} id - The ID of the HTML element
 * @returns {string} The value of the element
 */ function $67c86a85254b66ad$export$1e9c9f5af87d0888(element = document, id) {
    return element.getElementById(id).value;
}
/**
 * Gets the first element that matches a specified CSS selectors
 * @param {string} selector - The CSS selectors
 * @returns {Element} The first Element object that matches the specified CSS selector
 */ function $67c86a85254b66ad$export$78fb49a702cc1f2(element = document, selector) {
    return element.querySelector(selector);
}
/**
 * Gets the collection of elements that matches a specified CSS selectors
 * @param {string} selector - The CSS selectors
 * @returns {Element[]} The collection of elements that matches the specified CSS selector
 */ function $67c86a85254b66ad$export$2e83b5c43fb7af7b(element = document, selector) {
    return element.querySelectorAll(selector);
}
/**
 * Adds an event listener to an element
 * @param {Element} element - The target element
 * @param {string} event - The event to listen for
 * @param {Function} handler - The function to execute when the event is triggered
 */ function $67c86a85254b66ad$export$3f65cefe8380dbea(element, event, handler) {
    element.addEventListener(event, handler);
}
/**
 * This function generates error messages for a given product and key
 * @param {Object} data - The data in object
 * @param {string} clear - A flag indicating whether to clear the error messages
 */ function $67c86a85254b66ad$export$453b7056b2b0b6ac(formError) {
    // Clear all the error messages first
    const errorMsgElements = $67c86a85254b66ad$export$2e83b5c43fb7af7b("[data-field-error]");
    errorMsgElements.forEach((element)=>element.textContent = "");
    // Render all the error messages that in form error
    for(const key in formError){
        const value = formError[key];
        const errorMsgElement = $67c86a85254b66ad$export$78fb49a702cc1f2(`[data-field-error="${key}"]`);
        errorMsgElement.textContent = value;
    }
}


/**
 * Generates HTML for form inputs
 * @param {Array} props - An array of objects, each representing a form input
 * @param {string} props[].field - The name of the form field
 * @param {string} props[].value - The value of the form field
 * @param {string} props[].id - The id of the form field
 * @returns {string} The generated HTML string
 */ const $7f8d64953b3958b8$var$renderFormInputsHTML = (formInputs)=>{
    let formInputsHTML = ``;
    for (const item of formInputs){
        const { field: field, value: value, id: id } = item;
        formInputsHTML += `
      <div class="flex-column">
        <label class="label-primary" for="${id}">${field}</label>
        <input value="${value}" data-field="${field}" id="${id}" type="text" class="form-control input-size-md">
        <p data-field-error="${field}" class="error-message" id="${id}-error"></p>
      </div>
    `;
    }
    return formInputsHTML;
};
var $7f8d64953b3958b8$export$2e2bcd8739ae039 = $7f8d64953b3958b8$var$renderFormInputsHTML;


/**
 * Generates HTML for product info row
 * @param {Array} productInfos - An array of objects, each representing a product info
 * @param {string} productInfos[].term - The term of the product info
 * @param {string} productInfos[].value - The value of the product info
 * @returns {string} The generated HTML string
*/ const $0a8ec2e9aae2732b$var$renderProductInfoHTML = (productInfos)=>{
    let productInfosHTML = ``;
    for (const item of productInfos){
        const { term: term, value: value } = item;
        productInfosHTML += `
      <div class="product-info-row">
        <dt class="product-info-term">${term}</dt>
        <dd class="product-info-value">${value}</dd>
      </div>
    `;
    }
    return productInfosHTML;
};
var $0a8ec2e9aae2732b$export$2e2bcd8739ae039 = $0a8ec2e9aae2732b$var$renderProductInfoHTML;


class $265810a8cdd7a269$export$2e2bcd8739ae039 {
    /**
   * Clears the main content container on the page
   * Effectively removing all of its child elements
   */ clearMainContainer() {
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        mainContent.innerHTML = "";
    }
    /**
   * Displays product list of products on the view
   * @param {Object[]} products - An array of product objects to be displayed
   */ renderProducts(products) {
        this.clearMainContainer();
        const { EMPTY_PRODUCT_LIST_HEADING: EMPTY_PRODUCT_LIST_HEADING } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        if (!products || products.length === 0) {
            mainContent.innerHTML = `<h2 class="product-info">${EMPTY_PRODUCT_LIST_HEADING}</h2>`;
            return;
        }
        let productListHTML = '<ul class="main-products-container">';
        // Mapping over the products array to create HTML elements for each product
        products.forEach((product)=>{
            const { PRODUCTS_ENDPOINT: PRODUCTS_ENDPOINT } = (0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb);
            const { id: id, name: name, price: price, colors: colors, imgUrl: imgUrl } = product;
            const productHref = `${PRODUCTS_ENDPOINT}/${id}`;
            let colorOptionListHtml = ``;
            // Create list of product color element
            const colorOptionList = this.createColorOptionList(colors);
            // Appends color element to list in HTML
            colorOptionList.forEach((colorOptionItem)=>{
                colorOptionListHtml += colorOptionItem.outerHTML;
            });
            const productItemHTML = `
        <li class="product-item">
          <figure class="product-thumbnail">
            <a href="${productHref}">
              <img
              src="${imgUrl}" alt="${name}">
            </a>
            <div class="btn-group-action">
              <button id="btn-delete-${id}" data-id="${id}" class="btn btn-delete btn-primary"></button>
              <a href="/edit-product/${id}" class="btn btn-edit btn-primary">
                <svg height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </a>
            </div>
          </figure>
          <div class="product-details">
            <a href="${productHref}">
              <h2 title="${name}" class="product-title product-info">
                ${name}
              </h2>
            </a>
            <ul class="product-option-colors">
              ${colorOptionListHtml}
            </ul>
            <p class="product-info">$ ${price}</p>
          </div>
        </div>
      `;
            productListHTML += productItemHTML;
        });
        productListHTML += "</ul>";
        mainContent.innerHTML += productListHTML;
    }
    /**
   * Renders product form page
   */ renderProductFormPage(data = {}) {
        this.clearMainContainer();
        const { ADD_PRODUCT_HEADING: ADD_PRODUCT_HEADING, EDIT_PRODUCT_HEADING: EDIT_PRODUCT_HEADING } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const headingPage = Object.keys(data).length === 0 ? ADD_PRODUCT_HEADING : EDIT_PRODUCT_HEADING;
        const { id: id, name: name = "", price: price = "", colors: colors = "", brand: brand = "", modelName: modelName = "", formFactor: formFactor = "", connectivityTechnology: connectivityTechnology = "", amount: amount = "", imgUrl: imgUrl = "" } = data;
        let color = "";
        let hexCode = "";
        if (colors && colors.length > 0) ({ name: color, hexCode: hexCode } = colors[0]);
        const formInputs = [
            {
                field: "Name",
                value: name,
                id: "name"
            },
            {
                field: "Price",
                value: price,
                id: "price"
            },
            {
                field: "Brand",
                value: brand,
                id: "brand"
            },
            {
                field: "Model Name",
                value: modelName,
                id: "model-name"
            },
            {
                field: "Color",
                value: color,
                id: "color"
            },
            {
                field: "Hex Code",
                value: hexCode,
                id: "hex-code"
            },
            {
                field: "Form Factor",
                value: formFactor,
                id: "form-factor"
            },
            {
                field: "Connectivity Technology",
                value: connectivityTechnology,
                id: "connectivity-technology"
            },
            {
                field: "Amount",
                value: amount,
                id: "amount"
            },
            {
                field: "Image URL",
                value: imgUrl,
                id: "image-url"
            }
        ];
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        mainContent.innerHTML = `
      <div class="container add-product-container">
        <h2 class="main-heading">${headingPage}</h2>
        <form data-product-id="${id}" id="product-form" action="javascript:void(0)" class="form-default add-form">
          ${(0, $7f8d64953b3958b8$export$2e2bcd8739ae039)(formInputs)}
          <div class="flex-row form-btn-group">
            <a href="/" class="btn btn-cancel btn-primary btn-danger">Cancel</a>
            <button id="submit-button" type="submit" class="btn btn-primary btn-submit">Save</button>
          </div>
        </form>
      </div>
    `;
    }
    /**
   * Renders a product on the page
   * @param {Object} product - The product to render
   */ renderProduct(product) {
        const { id: id, name: name, price: price, colors: colors, brand: brand, modelName: modelName, formFactor: formFactor, connectivityTechnology: connectivityTechnology, amount: amount, imgUrl: imgUrl } = product;
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        let colorOptionListHtml = ``;
        // Create list of product color element
        const colorOptionList = this.createColorOptionList(colors);
        // Appends color element to list in HTML
        colorOptionList.forEach((colorOptionItem)=>{
            colorOptionListHtml += colorOptionItem.outerHTML;
        });
        const productInfos = [
            {
                term: "Brand",
                value: brand
            },
            {
                term: "Model Name",
                value: modelName
            },
            {
                term: "Color",
                value: colors[0].name
            },
            {
                term: "Form",
                value: formFactor
            },
            {
                term: "Connectivity Technology",
                value: connectivityTechnology
            },
            {
                term: "Amount",
                value: amount
            }
        ];
        mainContent.innerHTML = `
      <div class="container product-detail-container">
        <figure class="product-preview">
          <img src="${imgUrl}" alt="${name}">
        </figure>
        <div class="product-details">
          <h2 title="${name}" class="product-title product-info">${name}</h2>
          <ul id="product-option-colors" class="product-option-colors">
            ${colorOptionListHtml}
          </ul>
          <p class="product-info product-price">${price}</p>
          <dl class="product-data product-info">
            ${(0, $0a8ec2e9aae2732b$export$2e2bcd8739ae039)(productInfos)}
          </dl>
          <button id="btn-add-cart" class="btn btn-primary btn-success">Add to Cart</button>
          <input type="hidden" value="${id}" id="product-id" >
        </div>
      </div>
    `;
    }
    /**
   * Generates a list of color options for a product
   * @param {Object[]} colors An array of color object.
   * @returns {HTMLElement[]} An array of HTML elements representing color options
   */ createColorOptionList(colors) {
        const colorOptionList = [];
        for (let color of colors){
            const { name: name, hexCode: hexCode } = color;
            const productColorWrapperElement = (0, $67c86a85254b66ad$export$ad87ea24ece11d1d)({
                tag: "li"
            });
            // Creating the label element for each color
            const productColorLabelAttributes = {
                "data-color": name,
                "style": `background-color: ${hexCode}`,
                for: name
            };
            const productColorLabelElement = (0, $67c86a85254b66ad$export$ad87ea24ece11d1d)({
                tag: "label",
                className: "btn btn-option-color",
                attributes: productColorLabelAttributes
            });
            // Creating the radio button element for each color
            const colorValue = JSON.stringify({
                name: name,
                hexCode: hexCode
            });
            const productColorInputAttributes = {
                hidden: true,
                type: "radio",
                id: `color-${name}`,
                value: colorValue,
                name: "color"
            };
            const productColorInputElement = (0, $67c86a85254b66ad$export$ad87ea24ece11d1d)({
                tag: "input",
                attributes: productColorInputAttributes
            });
            productColorWrapperElement.append(productColorLabelElement, productColorInputElement);
            colorOptionList.push(productColorWrapperElement);
        }
        return colorOptionList;
    }
}




const $cbfa73536110cd9a$export$4ba0ff064c127035 = {
    /**
   * Fetches data from an URL and returns the JSON response.
   * If the fetching fails, it shows a toast notification
   * @param {string} endpoint - The endpoint to fetch data from
   * @returns {Promise<Object>} The JSON response
   */ async get (endpoint) {
        try {
            const url = `${(0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).BASE_URL}/${endpoint}`;
            const res = await fetch(url);
            if (!res.ok) throw new Error(`Failed to fetch data from ${url}`);
            const data = res.json();
            return data;
        } catch (error) {
            console.error(error);
        }
    },
    /**
   * Sends a POST request to the endpoint with the provided product data
   * @param {string} endpoint - The endpoint to which the request should be sent
   * @param {Object} product - The product data to be sent
   */ async post (endpoint, data) {
        try {
            const url = `${(0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).BASE_URL}/${endpoint}`;
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error(`Failed to post data to ${endpoint}`);
            return {
                isSuccess: true
            };
        } catch (error) {
            return {
                isSuccess: false
            };
        }
    },
    /**
   * Sends a PUT request to the specified endpoint
   * @param {string} endpoint - The endpoint to send the PUT request to
   * @param {Object} data - The data of the PUT request
   * @returns {Promise<Object>} The JSON response
   */ async put (endpoint, data) {
        try {
            const url = `${(0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).BASE_URL}/${endpoint}`;
            const res = await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error(`Failed to update data to ${endpoint}`);
            return {
                isSuccess: true
            };
        } catch (error) {
            return {
                isSuccess: true
            };
        }
    },
    /**
   * Sends a DELETE request to the specified endpoint
   * @param {string} endpoint - The endpoint to send the DELETE request to
   * @returns {Promise<Object>} The JSON response
   */ async delete (endpoint) {
        try {
            const url = `${(0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).BASE_URL}/${endpoint}`;
            const res = await fetch(url, {
                method: "DELETE"
            });
            if (!res.ok) throw new Error(`Failed to delete data from ${url}`);
            return {
                isSuccess: true
            };
        } catch (error) {
            return {
                isSuccess: false
            };
        }
    }
};


class $d35af98603bd490a$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    /**
   * Gets data from the api
   * @returns {Promise<Object[]>} An array of data objects
   */ async getAll() {
        return await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).get(this.endpoint);
    }
    /**
   * Gets a item by its ID
   * @param {string} id - The ID of the item
   * @returns {Promise<Object>} The object contains the item
   */ async getById(id) {
        return await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).get(`${this.endpoint}/${id}`);
    }
    /**
   * Add a new item
   * @param {Object} cartItem - the object contains the item
   * @param {Object} result - The result
   */ async add(cartItem) {
        return await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).post(this.endpoint, cartItem);
    }
    /**
   * Edit a item by its ID
   * @param {string} id - The ID of the item
   * @param {Object} result - The result
   */ async editById(id, data) {
        return await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).put(`${this.endpoint}/${id}`, data);
    }
    /**
   * Remove a item by its ID
   * @param {string} id - The ID of the item
   * @param {Object} result - The result
   */ async removeById(id) {
        return await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).delete(`${this.endpoint}/${id}`);
    }
}


class $57c80a6cc5448d97$export$2e2bcd8739ae039 extends (0, $d35af98603bd490a$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).PRODUCTS_ENDPOINT);
    }
}


var $e46560f007b189d3$exports = {};
/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */ (function(root, factory) {
    if (0, $e46560f007b189d3$exports) $e46560f007b189d3$exports = factory();
    else root.Toastify = factory();
})($e46560f007b189d3$exports, function(global) {
    // Object initialization
    var Toastify = function(options) {
        // Returning a new init object
        return new Toastify.lib.init(options);
    }, // Library version
    version = "1.12.0";
    // Set the default global options
    Toastify.defaults = {
        oldestFirst: true,
        text: "Toastify is awesome!",
        node: undefined,
        duration: 3000,
        selector: undefined,
        callback: function() {},
        destination: undefined,
        newWindow: false,
        close: false,
        gravity: "toastify-top",
        positionLeft: false,
        position: "",
        backgroundColor: "",
        avatar: "",
        className: "",
        stopOnFocus: true,
        onClick: function() {},
        offset: {
            x: 0,
            y: 0
        },
        escapeMarkup: true,
        ariaLive: "polite",
        style: {
            background: ""
        }
    };
    // Defining the prototype of the object
    Toastify.lib = Toastify.prototype = {
        toastify: version,
        constructor: Toastify,
        // Initializing the object with required parameters
        init: function(options) {
            // Verifying and validating the input object
            if (!options) options = {};
            // Creating the options object
            this.options = {};
            this.toastElement = null;
            // Validating the options
            this.options.text = options.text || Toastify.defaults.text; // Display message
            this.options.node = options.node || Toastify.defaults.node; // Display content as node
            this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify.defaults.duration; // Display duration
            this.options.selector = options.selector || Toastify.defaults.selector; // Parent selector
            this.options.callback = options.callback || Toastify.defaults.callback; // Callback after display
            this.options.destination = options.destination || Toastify.defaults.destination; // On-click destination
            this.options.newWindow = options.newWindow || Toastify.defaults.newWindow; // Open destination in new window
            this.options.close = options.close || Toastify.defaults.close; // Show toast close icon
            this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify.defaults.gravity; // toast position - top or bottom
            this.options.positionLeft = options.positionLeft || Toastify.defaults.positionLeft; // toast position - left or right
            this.options.position = options.position || Toastify.defaults.position; // toast position - left or right
            this.options.backgroundColor = options.backgroundColor || Toastify.defaults.backgroundColor; // toast background color
            this.options.avatar = options.avatar || Toastify.defaults.avatar; // img element src - url or a path
            this.options.className = options.className || Toastify.defaults.className; // additional class names for the toast
            this.options.stopOnFocus = options.stopOnFocus === undefined ? Toastify.defaults.stopOnFocus : options.stopOnFocus; // stop timeout on focus
            this.options.onClick = options.onClick || Toastify.defaults.onClick; // Callback after click
            this.options.offset = options.offset || Toastify.defaults.offset; // toast offset
            this.options.escapeMarkup = options.escapeMarkup !== undefined ? options.escapeMarkup : Toastify.defaults.escapeMarkup;
            this.options.ariaLive = options.ariaLive || Toastify.defaults.ariaLive;
            this.options.style = options.style || Toastify.defaults.style;
            if (options.backgroundColor) this.options.style.background = options.backgroundColor;
            // Returning the current object for chaining functions
            return this;
        },
        // Building the DOM element
        buildToast: function() {
            // Validating if the options are defined
            if (!this.options) throw "Toastify is not initialized";
            // Creating the DOM object
            var divElement = document.createElement("div");
            divElement.className = "toastify on " + this.options.className;
            // Positioning toast to left or right or center
            if (!!this.options.position) divElement.className += " toastify-" + this.options.position;
            else // To be depreciated in further versions
            if (this.options.positionLeft === true) {
                divElement.className += " toastify-left";
                console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.");
            } else // Default position
            divElement.className += " toastify-right";
            // Assigning gravity of element
            divElement.className += " " + this.options.gravity;
            if (this.options.backgroundColor) // This is being deprecated in favor of using the style HTML DOM property
            console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
            // Loop through our style object and apply styles to divElement
            for(var property in this.options.style)divElement.style[property] = this.options.style[property];
            // Announce the toast to screen readers
            if (this.options.ariaLive) divElement.setAttribute("aria-live", this.options.ariaLive);
            // Adding the toast message/node
            if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) // If we have a valid node, we insert it
            divElement.appendChild(this.options.node);
            else {
                if (this.options.escapeMarkup) divElement.innerText = this.options.text;
                else divElement.innerHTML = this.options.text;
                if (this.options.avatar !== "") {
                    var avatarElement = document.createElement("img");
                    avatarElement.src = this.options.avatar;
                    avatarElement.className = "toastify-avatar";
                    if (this.options.position == "left" || this.options.positionLeft === true) // Adding close icon on the left of content
                    divElement.appendChild(avatarElement);
                    else // Adding close icon on the right of content
                    divElement.insertAdjacentElement("afterbegin", avatarElement);
                }
            }
            // Adding a close icon to the toast
            if (this.options.close === true) {
                // Create a span for close element
                var closeElement = document.createElement("button");
                closeElement.type = "button";
                closeElement.setAttribute("aria-label", "Close");
                closeElement.className = "toast-close";
                closeElement.innerHTML = "&#10006;";
                // Triggering the removal of toast from DOM on close click
                closeElement.addEventListener("click", (function(event) {
                    event.stopPropagation();
                    this.removeElement(this.toastElement);
                    window.clearTimeout(this.toastElement.timeOutValue);
                }).bind(this));
                //Calculating screen width
                var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
                // Adding the close icon to the toast element
                // Display on the right if screen width is less than or equal to 360px
                if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) // Adding close icon on the left of content
                divElement.insertAdjacentElement("afterbegin", closeElement);
                else // Adding close icon on the right of content
                divElement.appendChild(closeElement);
            }
            // Clear timeout while toast is focused
            if (this.options.stopOnFocus && this.options.duration > 0) {
                var self = this;
                // stop countdown
                divElement.addEventListener("mouseover", function(event) {
                    window.clearTimeout(divElement.timeOutValue);
                });
                // add back the timeout
                divElement.addEventListener("mouseleave", function() {
                    divElement.timeOutValue = window.setTimeout(function() {
                        // Remove the toast from DOM
                        self.removeElement(divElement);
                    }, self.options.duration);
                });
            }
            // Adding an on-click destination path
            if (typeof this.options.destination !== "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                if (this.options.newWindow === true) window.open(this.options.destination, "_blank");
                else window.location = this.options.destination;
            }).bind(this));
            if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                this.options.onClick();
            }).bind(this));
            // Adding offset
            if (typeof this.options.offset === "object") {
                var x = getAxisOffsetAValue("x", this.options);
                var y = getAxisOffsetAValue("y", this.options);
                var xOffset = this.options.position == "left" ? x : "-" + x;
                var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
                divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
            }
            // Returning the generated element
            return divElement;
        },
        // Displaying the toast
        showToast: function() {
            // Creating the DOM object for the toast
            this.toastElement = this.buildToast();
            // Getting the root element to with the toast needs to be added
            var rootElement;
            if (typeof this.options.selector === "string") rootElement = document.getElementById(this.options.selector);
            else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== "undefined" && this.options.selector instanceof ShadowRoot) rootElement = this.options.selector;
            else rootElement = document.body;
            // Validating if root element is present in DOM
            if (!rootElement) throw "Root element is not defined";
            // Adding the DOM element
            var elementToInsert = Toastify.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
            rootElement.insertBefore(this.toastElement, elementToInsert);
            // Repositioning the toasts in case multiple toasts are present
            Toastify.reposition();
            if (this.options.duration > 0) this.toastElement.timeOutValue = window.setTimeout((function() {
                // Remove the toast from DOM
                this.removeElement(this.toastElement);
            }).bind(this), this.options.duration); // Binding `this` for function invocation
            // Supporting function chaining
            return this;
        },
        hideToast: function() {
            if (this.toastElement.timeOutValue) clearTimeout(this.toastElement.timeOutValue);
            this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(toastElement) {
            // Hiding the element
            // toastElement.classList.remove("on");
            toastElement.className = toastElement.className.replace(" on", "");
            // Removing the element from DOM after transition end
            window.setTimeout((function() {
                // remove options node if any
                if (this.options.node && this.options.node.parentNode) this.options.node.parentNode.removeChild(this.options.node);
                // Remove the element from the DOM, only when the parent node was not removed before.
                if (toastElement.parentNode) toastElement.parentNode.removeChild(toastElement);
                // Calling the callback function
                this.options.callback.call(toastElement);
                // Repositioning the toasts again
                Toastify.reposition();
            }).bind(this), 400); // Binding `this` for function invocation
        }
    };
    // Positioning the toasts on the DOM
    Toastify.reposition = function() {
        // Top margins with gravity
        var topLeftOffsetSize = {
            top: 15,
            bottom: 15
        };
        var topRightOffsetSize = {
            top: 15,
            bottom: 15
        };
        var offsetSize = {
            top: 15,
            bottom: 15
        };
        // Get all toast messages on the DOM
        var allToasts = document.getElementsByClassName("toastify");
        var classUsed;
        // Modifying the position of each toast element
        for(var i = 0; i < allToasts.length; i++){
            // Getting the applied gravity
            if (containsClass(allToasts[i], "toastify-top") === true) classUsed = "toastify-top";
            else classUsed = "toastify-bottom";
            var height = allToasts[i].offsetHeight;
            classUsed = classUsed.substr(9, classUsed.length - 1);
            // Spacing between toasts
            var offset = 15;
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            // Show toast in center if screen with less than or equal to 360px
            if (width <= 360) {
                // Setting the position
                allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
                offsetSize[classUsed] += height + offset;
            } else if (containsClass(allToasts[i], "toastify-left") === true) {
                // Setting the position
                allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
                topLeftOffsetSize[classUsed] += height + offset;
            } else {
                // Setting the position
                allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
                topRightOffsetSize[classUsed] += height + offset;
            }
        }
        // Supporting function chaining
        return this;
    };
    // Helper function to get offset.
    function getAxisOffsetAValue(axis, options) {
        if (options.offset[axis]) {
            if (isNaN(options.offset[axis])) return options.offset[axis];
            else return options.offset[axis] + "px";
        }
        return "0px";
    }
    function containsClass(elem, yourClass) {
        if (!elem || typeof yourClass !== "string") return false;
        else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) return true;
        else return false;
    }
    // Setting up the prototype for the init object
    Toastify.lib.init.prototype = Toastify.lib;
    // Returning the Toastify function to be assigned to the window object/module
    return Toastify;
});



/**
 * Toast object for displaying success and error messages
 */ const $45c0068f810095da$var$Toast = {
    /**
   * Displays a success message using showToastify
   * @param {string} msg - The message to be displayed
   */ success (msg) {
        $45c0068f810095da$var$showToastify(msg, "toastify-success");
    },
    /**
   * Displays an error message using showToastify
   * @param {string} msg - The message to be displayed
   */ error (msg) {
        $45c0068f810095da$var$showToastify(msg, "toastify-danger");
    }
};
/**
 * Displays a toast notification
 * @param {string} msg - The message to display in the toast
 * @param {string} state - The state of the toast (e.g., 'toastify-success', 'toastify-danger')
 * @param {number} [duration=2000] - The duration (in milliseconds) for which the toast should be displayed
 * @example
 * showToastify('Product added successfully!', 'toastify-success', 2000);
 */ function $45c0068f810095da$var$showToastify(msg, state, duration = 2000) {
    (0, (/*@__PURE__*/$parcel$interopDefault($e46560f007b189d3$exports)))({
        text: msg,
        duration: duration,
        newWindow: true,
        gravity: "center",
        position: "center",
        stopOnFocus: true,
        className: state
    }).showToast();
}
var $45c0068f810095da$export$2e2bcd8739ae039 = $45c0068f810095da$var$Toast;




class $9bb90f3267803406$export$2e2bcd8739ae039 {
    constructor(view, service){
        this.view = view;
        this.service = service;
    }
    /**
   * Calls displaying products
   */ async init() {
        await this.displayProducts();
    }
    /**
   * Fetches products from the server and displays them
   */ async displayProducts() {
        const products = await this.service.getAll();
        this.view.renderProducts(products);
        this.bindDeleteProductEvent();
    }
    /**
   * Binds the delete product event to each delete button
   * If the deletion is successful, it re-displays the products
   */ bindDeleteProductEvent() {
        const { DELETE_PRODUCT_SUCCESS_MSG: DELETE_PRODUCT_SUCCESS_MSG, DELETE_PRODUCT_FAILED_MSG: DELETE_PRODUCT_FAILED_MSG } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const productListElement = (0, $67c86a85254b66ad$export$78fb49a702cc1f2)(".main-products-container");
        (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(productListElement, "click", async (e)=>{
            const { target: target } = e;
            if (!target.classList.contains("btn-delete")) return;
            const id = target.dataset.id;
            if (!confirm((0, $b0227b060345e8b7$export$2e2bcd8739ae039).DELETE_CONFIRMATION_MSG)) return;
            const { isSuccess: isSuccess } = await this.service.deleteById(id);
            if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(DELETE_PRODUCT_FAILED_MSG);
            (0, $45c0068f810095da$export$2e2bcd8739ae039).success(DELETE_PRODUCT_SUCCESS_MSG);
            this.displayProducts();
        });
    }
}



const $2d17f91514a692d2$export$a803b6d313acce4 = {
    wordRegexStr: "\\w+",
    integerRegex: /^-?\d+$/,
    digitRegex: /^-?\d*\.?\d+$/,
    hexCodeRegex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8})$/,
    camelCaseRegex: /([a-z])([A-Z])/g,
    firstCharacterRegex: /^./
};


let $9c0fcd659e026590$var$formError = {};
const { digitRegex: $9c0fcd659e026590$var$digitRegex, integerRegex: $9c0fcd659e026590$var$integerRegex, hexCodeRegex: $9c0fcd659e026590$var$hexCodeRegex } = (0, $2d17f91514a692d2$export$a803b6d313acce4);
/**
 * Checks if the value is a string
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {string} params.value - The value of that field
 */ const $9c0fcd659e026590$export$d7b0a588f685ba7e = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = typeof value !== "string" ? `${key} must be a string.` : "";
/**
 * Checks if the value is a number
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {number} params.value - The value of that field
 */ const $9c0fcd659e026590$export$ffa3b1cd345d970 = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = !$9c0fcd659e026590$var$integerRegex.test(value) ? `${key} must be an integer.` : "";
/**
 * Checks if the value is a number
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {number} params.value - The value of that field
 */ const $9c0fcd659e026590$export$54409f412ca1ee8b = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = !$9c0fcd659e026590$var$digitRegex.test(value) ? `${key} must be a float.` : "";
/**
 * Checks if the value is a number
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {number} params.value - The value of that field
 */ const $9c0fcd659e026590$export$f0164982c64cb22 = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = value.trim() === "" ? `${key} is required.` : "";
/**
 * Checks if the value is longer than mininum length
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {string} params.value - The value of that field
 */ const $9c0fcd659e026590$export$929c2d4e93746bc6 = ({ key: key, value: value, min: min = 6 })=>$9c0fcd659e026590$var$formError[key] = value.trim().length < min ? `${key} must have at least ${min} characters.` : "";
/**
 * Checks if the value is a positive number
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {number} params.value - The value of that field
 */ const $9c0fcd659e026590$export$d896bf2c50b7d6df = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = parseFloat(value) < 0 ? `${key} needs to be a positive number.` : "";
/**
 * Checks if the value is a hex code
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {string} params.value - The value of that field
 */ const $9c0fcd659e026590$export$fa7ab351b0da5ad = ({ key: key, value: value })=>$9c0fcd659e026590$var$formError[key] = !$9c0fcd659e026590$var$hexCodeRegex.test(value) ? `${key} needs to be a correct hex code eg: #333.` : "";
/**
 * Checks if the value is a valid url
 * @param {Object} params - An object
 * @param {string} params.key - The field that needs to check
 * @param {string} params.value - The value of that field
 */ function $9c0fcd659e026590$export$52213319c01858f({ key: key, value: value }) {
    if (key in $9c0fcd659e026590$var$formError && $9c0fcd659e026590$var$formError[key] !== "") return;
    try {
        new URL(value);
        const fileExtension = value.split(".").pop().toLowerCase();
        if ([
            "jpg",
            "jpeg",
            "png"
        ].includes(fileExtension)) $9c0fcd659e026590$var$formError[key] = "";
        else $9c0fcd659e026590$var$formError[key] = `${key} must be a valid image URL (jpg, jpeg, or png).`;
    } catch (error) {
        $9c0fcd659e026590$var$formError[key] = `${key} must be a valid URL.`;
    }
}
/**
 * Validates the form data
 * @param {Object} data - The form data
 * @returns {Object} An object containing validation results
 */ function $9c0fcd659e026590$export$ed692cabb252e59b(validationSchema) {
    $9c0fcd659e026590$var$formError = {};
    for(const key in validationSchema){
        const { field: field, value: value, validators: validators } = validationSchema[key];
        $9c0fcd659e026590$export$f0164982c64cb22({
            key: field,
            value: value
        });
        for (const validator of validators){
            if ($9c0fcd659e026590$var$formError[field] !== "") break;
            validator({
                key: field,
                value: value
            });
        }
    }
    return {
        formError: $9c0fcd659e026590$var$formError
    };
}


const $fbbe67d1c1dc0a71$export$cd891b82501bb412 = {
    HOME: "/",
    PRODUCT_DETAIL: "/products/:id",
    ADD_PRODUCT: "/add-product",
    EDIT_PRODUCT: "/edit-product/:id",
    CART: "/cart"
};



function $4672f44f88bd2bca$export$2e2bcd8739ae039(pathName) {
    for(let route in 0, $fbbe67d1c1dc0a71$export$cd891b82501bb412){
        const routePath = (0, $fbbe67d1c1dc0a71$export$cd891b82501bb412)[route];
        // If the route exactly matches the path name
        if (routePath === pathName) return {
            route: routePath,
            params: {}
        };
        // If the route includes an ':id' parameter
        if (routePath.includes(":id")) {
            const { wordRegexStr: wordRegexStr } = (0, $2d17f91514a692d2$export$a803b6d313acce4);
            // Create a regular expression to match the route, replacing ':id' with a digit pattern
            const regex = new RegExp(routePath.replace(":id", wordRegexStr));
            if (regex.test(pathName)) return {
                route: routePath,
                params: {
                    id: pathName.split("/")[2]
                }
            };
        }
    }
    return {};
}


const $3bf36c6027be03bc$export$9523889e0a5da4ba = {
    ADD: "add",
    EDIT: "edit",
    INCREMENT: "increment",
    DECREMENT: "decrement"
};





class $187b462c973291f1$export$2e2bcd8739ae039 {
    constructor(view, service, action){
        this.view = view;
        this.service = service;
        this.action = action;
    }
    /**
   * Calls displaying product-form page
   */ async init() {
        await this.displayProductFormPage();
    }
    /**
   * Renders add-product page
   */ async displayProductFormPage() {
        let data = {};
        if (this.action === (0, $3bf36c6027be03bc$export$9523889e0a5da4ba).EDIT) {
            const { params: params } = (0, $4672f44f88bd2bca$export$2e2bcd8739ae039)(window.location.pathname);
            data = await this.service.getById(params.id);
        }
        this.view.renderProductFormPage(data);
        this.bindProductFormEvent();
    }
    /**
   * Binds event to handle product addition
   */ bindProductFormEvent() {
        const { ADD_PRODUCT_FAILED_MSG: ADD_PRODUCT_FAILED_MSG, ADD_PRODUCT_SUCCESS_MSG: ADD_PRODUCT_SUCCESS_MSG, UPDATE_ITEM_FAILED_MSG: UPDATE_ITEM_FAILED_MSG, UPDATE_ITEM_SUCCESS_MSG: UPDATE_ITEM_SUCCESS_MSG } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const submitBtnElement = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("submit-button");
        // Bind the click event to the 'Add Product' button
        (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(submitBtnElement, "click", async (event)=>{
            event.preventDefault();
            // Get the values from the form inputs
            const nameValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("name");
            const priceValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("price");
            const brandValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("brand");
            const modelNameValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("model-name");
            const colorNameValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("color");
            const hexCodeValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("hex-code");
            const formFactorValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("form-factor");
            const connectivityTechnologyValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("connectivity-technology");
            const amountValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("amount");
            const imageUrlValue = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("image-url");
            const validationSchema = {
                name: {
                    field: "Name",
                    value: nameValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e),
                        (0, $9c0fcd659e026590$export$929c2d4e93746bc6)
                    ]
                },
                price: {
                    field: "Price",
                    value: priceValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$54409f412ca1ee8b),
                        (0, $9c0fcd659e026590$export$d896bf2c50b7d6df)
                    ]
                },
                brand: {
                    field: "Brand",
                    value: brandValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e)
                    ]
                },
                modelName: {
                    field: "Model Name",
                    value: modelNameValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e)
                    ]
                },
                color: {
                    field: "Color",
                    value: colorNameValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e)
                    ]
                },
                hexCode: {
                    field: "Hex Code",
                    value: hexCodeValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$fa7ab351b0da5ad)
                    ]
                },
                formFactor: {
                    field: "Form Factor",
                    value: formFactorValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e)
                    ]
                },
                connectivityTechnology: {
                    field: "Connectivity Technology",
                    value: connectivityTechnologyValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$d7b0a588f685ba7e)
                    ]
                },
                amount: {
                    field: "Amount",
                    value: amountValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$ffa3b1cd345d970),
                        (0, $9c0fcd659e026590$export$d896bf2c50b7d6df)
                    ]
                },
                imgUrl: {
                    field: "Image URL",
                    value: imageUrlValue,
                    validators: [
                        (0, $9c0fcd659e026590$export$52213319c01858f)
                    ]
                }
            };
            const { formError: formError } = (0, $9c0fcd659e026590$export$ed692cabb252e59b)(validationSchema);
            // Generate new error messages based on the validation results
            (0, $67c86a85254b66ad$export$453b7056b2b0b6ac)(formError);
            // If there are any validation errors, stop the function
            const isPassed = Object.values(formError).every((value)=>value === "");
            if (!isPassed) return;
            const product = {
                name: nameValue,
                price: priceValue,
                brand: brandValue,
                modelName: modelNameValue,
                colors: [
                    {
                        name: colorNameValue,
                        hexCode: hexCodeValue
                    }
                ],
                formFactor: formFactorValue,
                connectivityTechnology: connectivityTechnologyValue,
                amount: amountValue,
                imgUrl: imageUrlValue
            };
            switch(this.action){
                case (0, $3bf36c6027be03bc$export$9523889e0a5da4ba).ADD:
                    {
                        const { isSuccess: isSuccess } = await this.service.add(product);
                        if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(ADD_PRODUCT_FAILED_MSG);
                        (0, $45c0068f810095da$export$2e2bcd8739ae039).success(ADD_PRODUCT_SUCCESS_MSG);
                        return (0, $4829e72bb21d5fc4$export$e9f61d36381871f3)({
                            href: "/"
                        });
                    }
                case (0, $3bf36c6027be03bc$export$9523889e0a5da4ba).EDIT:
                    {
                        const { params: params } = (0, $4672f44f88bd2bca$export$2e2bcd8739ae039)(window.location.pathname);
                        const { isSuccess: isSuccess } = await this.service.editById(params.id, product);
                        if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(UPDATE_ITEM_FAILED_MSG);
                        (0, $45c0068f810095da$export$2e2bcd8739ae039).success(UPDATE_ITEM_SUCCESS_MSG);
                        break;
                    }
            }
            this.displayProductFormPage();
        });
    }
}






class $85bc8b5954cedd46$export$2e2bcd8739ae039 {
    constructor(view, services){
        this.view = view;
        this.productService = services.productService;
        this.cartService = services.cartService;
    }
    /**
   * Calling displaying product-detail page
   */ async init() {
        await this.displayProductDetail();
    }
    /**
   * Fetches product by id from the server and displays them
   */ async displayProductDetail() {
        const { params: params } = (0, $4672f44f88bd2bca$export$2e2bcd8739ae039)(window.location.pathname);
        const product = await this.productService.getById(params.id);
        this.view.renderProduct(product);
        this.bindAddCartBtnEvent();
    }
    /**
   * Binds events to handle add product to cart
   */ bindAddCartBtnEvent() {
        const { PRODUCT_EMPTY_MSG: PRODUCT_EMPTY_MSG, ADD_CART_SUCCESS_MSG: ADD_CART_SUCCESS_MSG, ADD_CART_FAILED_MSG: ADD_CART_FAILED_MSG, INCREMENT_CART_FAILED_MSG: INCREMENT_CART_FAILED_MSG, UPDATE_ITEM_FAILED_MSG: UPDATE_ITEM_FAILED_MSG } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const addCartItemBtnElement = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("btn-add-cart");
        (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(addCartItemBtnElement, "click", async ()=>{
            const productId = (0, $67c86a85254b66ad$export$1e9c9f5af87d0888)("product-id");
            const product = await this.productService.getById(productId);
            const { name: name, colors: colors, price: price, imgUrl: imgUrl, amount: productAmount } = product || {};
            const cartItem = await this.cartService.getByProductId(productId);
            const { id: cartItemId, amount: cartItemAmount } = cartItem || {};
            if (productAmount <= 0) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(PRODUCT_EMPTY_MSG);
            // Update item amount if user already add it to cart
            if (cartItem) {
                if (cartItemAmount >= productAmount) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(INCREMENT_CART_FAILED_MSG);
                cartItem.amount += 1;
                const { isSuccess: isSuccess } = await this.cartService.editById(cartItemId, cartItem);
                if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(UPDATE_ITEM_FAILED_MSG);
                return (0, $45c0068f810095da$export$2e2bcd8739ae039).success(ADD_CART_SUCCESS_MSG);
            }
            const newCartItem = {
                name: name,
                productId: productId,
                color: colors[0].name,
                price: price,
                amount: 1,
                imgUrl: imgUrl
            };
            const { isSuccess: isSuccess } = await this.cartService.add(newCartItem);
            if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(ADD_CART_FAILED_MSG);
            (0, $45c0068f810095da$export$2e2bcd8739ae039).success(ADD_CART_SUCCESS_MSG);
        });
    }
}




class $91e5f1d28f97ed12$export$2e2bcd8739ae039 {
    /**
   * Clears the main content container on the page
   * Effectively removing all of its child elements
   */ clearMainContainer() {
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        mainContent.innerHTML = "";
    }
    /**
   * Renders list of cart items on the page
   */ renderCart(cart) {
        this.clearMainContainer();
        const { EMPTY_CART_HEADING: EMPTY_CART_HEADING } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const mainContent = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)("main-content");
        if (!cart || cart.length === 0) {
            mainContent.innerHTML = `<h2 class="product-info">${EMPTY_CART_HEADING}</h2>`;
            return;
        }
        let cartListHTML = '<ul class="shopping-cart">';
        for (const item of cart){
            const { id: id, productId: productId, name: name, color: color, amount: amount, price: price, imgUrl: imgUrl } = item;
            const totalPrice = amount * price;
            const cartItemHTML = `
       <li class="cart-item">
        <div class="cart-item-image">
          <button id="btn-delete-${id}" data-cart-item-id="${id}" type="button" class="btn btn-primary btn-delete-cart-item">X</button>
          <figure class="product-thumbnail">
            <img src="${imgUrl}" alt="${name}" />
          </figure>
        </div>
        <div class="cart-item-info">
          <h2 title="${name}" class="product-info product-title">${name}</h2>
          <p class="cart-item-color">${color}</p>
        </div>
        <div class="cart-item-quantity">
          <button data-action="increment" data-cart-item-id="${id}" data-product-id="${productId}" class="btn btn-plus" type="button">
            +
          </button>
          <input id="amount-input-${id}" value="${amount}" disabled type="text" class="form-control input-quantity">
          <button data-action="decrement" data-cart-item-id="${id}" data-product-id="${productId}" class="btn btn-minus" type="button">
            -
          </button>
        </div>
        <p id="product-total-${id}" class="product-total product-info">$ ${totalPrice.toFixed(2)}</p>
       </li>
      `;
            cartListHTML += cartItemHTML;
        }
        cartListHTML += "</ul>";
        mainContent.innerHTML += cartListHTML;
    }
}





class $13db03ca8576a8aa$export$2e2bcd8739ae039 extends (0, $d35af98603bd490a$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).CART_ENDPOINT);
    }
    /**
   * Gets a cart item by its product ID
   * @param {string} id - The ID of the product
   * @returns {Promise<Object>} The object contains the cart item
   */ async getByProductId(id) {
        const data = await (0, $cbfa73536110cd9a$export$4ba0ff064c127035).get(`${(0, $4b44dfc9bfcfa55a$export$9c2c88dbfc01c8fb).CART_ENDPOINT}?productId=${id}`);
        return data[0];
    }
}






class $3eaea190359e6c36$export$2e2bcd8739ae039 {
    constructor(view, services){
        this.view = view;
        this.cartService = services.cartService;
        this.productService = services.productService;
    }
    /**
   * Calls displaying cart page
   */ async init() {
        await this.displayCartPage();
    }
    /**
   * Deletes a cart item by its ID after user confirmation
   * @param {string} id - The ID of the cart item to be deleted
   */ async deleteCartItem(id) {
        const { DELETE_CONFIRMATION_MSG: DELETE_CONFIRMATION_MSG, DELETE_CART_FAILED_MSG: DELETE_CART_FAILED_MSG, DELETE_CART_SUCCESS_MSG: DELETE_CART_SUCCESS_MSG } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        if (!confirm(DELETE_CONFIRMATION_MSG)) return;
        const { isSuccess: isSuccess } = await this.cartService.removeById(id);
        if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(DELETE_CART_FAILED_MSG);
        (0, $45c0068f810095da$export$2e2bcd8739ae039).success(DELETE_CART_SUCCESS_MSG);
        this.displayCartPage();
    }
    /**
   * Fetches cart from the server and displays them
   */ async displayCartPage() {
        const cart = await this.cartService.getAll();
        this.view.renderCart(cart);
        this.bindDeleteItemBtnEvent();
        this.bindModifyAmountBtnEvent();
    }
    /**
   * Binds event to handle update cart item amount
   */ bindModifyAmountBtnEvent() {
        const { UPDATE_ITEM_FAILED_MSG: UPDATE_ITEM_FAILED_MSG, INCREMENT_CART_FAILED_MSG: INCREMENT_CART_FAILED_MSG } = (0, $b0227b060345e8b7$export$2e2bcd8739ae039);
        const btnPlusElements = (0, $67c86a85254b66ad$export$2e83b5c43fb7af7b)(".btn-plus");
        const btnMinusElements = (0, $67c86a85254b66ad$export$2e83b5c43fb7af7b)(".btn-minus");
        // This function handles the click event of the plus and minus buttons
        const handleModifyAmount = async (e)=>{
            const dataset = e.target.dataset;
            const { action: action, cartItemId: cartItemId, productId: productId } = dataset;
            const amountInputElement = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)(`amount-input-${cartItemId}`);
            const productTotalElement = (0, $67c86a85254b66ad$export$83595b84fc78b9b4)(`product-total-${cartItemId}`);
            // Get the product amount from the product service
            const product = await this.productService.getById(productId);
            const { amount: productAmount } = product;
            // Get the cart item amount and price from the product service
            const existingCartItem = await this.cartService.getByProductId(productId);
            const { amount: cartItemAmount, price: price } = existingCartItem ? existingCartItem : {};
            const { INCREMENT: INCREMENT, DECREMENT: DECREMENT } = (0, $3bf36c6027be03bc$export$9523889e0a5da4ba);
            switch(action){
                case INCREMENT:
                    {
                        if (cartItemAmount >= productAmount) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(INCREMENT_CART_FAILED_MSG);
                        // Update the cart item with amount +1
                        existingCartItem.amount += 1;
                        const { isSuccess: isSuccess } = await this.cartService.editById(cartItemId, existingCartItem);
                        if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(UPDATE_ITEM_FAILED_MSG);
                        let amount = parseInt(amountInputElement.value);
                        const priceFloat = parseFloat(price);
                        amountInputElement.value = ++amount;
                        const total = (amount * priceFloat).toFixed(2);
                        productTotalElement.textContent = `$ ${total}`;
                        break;
                    }
                case DECREMENT:
                    {
                        if (cartItemAmount <= 1) return this.deleteCartItem(cartItemId);
                        // Update the cart item with amount -1
                        existingCartItem.amount -= 1;
                        const { isSuccess: isSuccess } = await this.cartService.editById(cartItemId, existingCartItem);
                        if (!isSuccess) return (0, $45c0068f810095da$export$2e2bcd8739ae039).error(UPDATE_ITEM_FAILED_MSG);
                        let amount = parseInt(amountInputElement.value);
                        const priceFloat = parseFloat(price);
                        amountInputElement.value = --amount;
                        const total = (amount * priceFloat).toFixed(2);
                        productTotalElement.textContent = `$ ${total}`;
                        break;
                    }
            }
        };
        btnPlusElements.forEach((element)=>{
            (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(element, "click", handleModifyAmount);
        });
        btnMinusElements.forEach((element)=>{
            (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(element, "click", handleModifyAmount);
        });
    }
    /**
   * Binds event to handle remove item from cart
   */ bindDeleteItemBtnEvent() {
        const cartListElement = (0, $67c86a85254b66ad$export$78fb49a702cc1f2)(".shopping-cart");
        (0, $67c86a85254b66ad$export$3f65cefe8380dbea)(cartListElement, "click", async (e)=>{
            const btnDeleteCartItemElement = e.target.classList.contains("btn-delete-cart-item");
            if (btnDeleteCartItemElement) {
                const id = e.target.dataset.cartItemId;
                this.deleteCartItem(id);
            }
        });
    }
}






const $4829e72bb21d5fc4$var$productView = new (0, $265810a8cdd7a269$export$2e2bcd8739ae039)();
const $4829e72bb21d5fc4$var$productService = new (0, $57c80a6cc5448d97$export$2e2bcd8739ae039)();
const $4829e72bb21d5fc4$var$cartView = new (0, $91e5f1d28f97ed12$export$2e2bcd8739ae039)();
const $4829e72bb21d5fc4$var$cartService = new (0, $13db03ca8576a8aa$export$2e2bcd8739ae039)();
const $4829e72bb21d5fc4$var$productDetailServices = {
    productService: $4829e72bb21d5fc4$var$productService,
    cartService: $4829e72bb21d5fc4$var$cartService
};
/**
 * An object that maps route names to their respective handlers
 */ const $4829e72bb21d5fc4$var$routes = {
    [(0, $fbbe67d1c1dc0a71$export$cd891b82501bb412).HOME]: {
        handler: ()=>{
            return new (0, $9bb90f3267803406$export$2e2bcd8739ae039)($4829e72bb21d5fc4$var$productView, $4829e72bb21d5fc4$var$productService);
        }
    },
    [(0, $fbbe67d1c1dc0a71$export$cd891b82501bb412).PRODUCT_DETAIL]: {
        handler: ()=>{
            return new (0, $85bc8b5954cedd46$export$2e2bcd8739ae039)($4829e72bb21d5fc4$var$productView, $4829e72bb21d5fc4$var$productDetailServices);
        }
    },
    [(0, $fbbe67d1c1dc0a71$export$cd891b82501bb412).ADD_PRODUCT]: {
        handler: ()=>{
            return new (0, $187b462c973291f1$export$2e2bcd8739ae039)($4829e72bb21d5fc4$var$productView, $4829e72bb21d5fc4$var$productService, (0, $3bf36c6027be03bc$export$9523889e0a5da4ba).ADD);
        }
    },
    [(0, $fbbe67d1c1dc0a71$export$cd891b82501bb412).EDIT_PRODUCT]: {
        handler: ()=>{
            return new (0, $187b462c973291f1$export$2e2bcd8739ae039)($4829e72bb21d5fc4$var$productView, $4829e72bb21d5fc4$var$productService, (0, $3bf36c6027be03bc$export$9523889e0a5da4ba).EDIT);
        }
    },
    [(0, $fbbe67d1c1dc0a71$export$cd891b82501bb412).CART]: {
        handler: ()=>{
            return new (0, $3eaea190359e6c36$export$2e2bcd8739ae039)($4829e72bb21d5fc4$var$cartView, $4829e72bb21d5fc4$var$productDetailServices);
        }
    }
};
// Add an event listener for clicking all links
// This is necessary because the website is a
// Single Page Application and does not need to reload
// which can lead to a faster user experience
(0, $67c86a85254b66ad$export$3f65cefe8380dbea)(document, "click", (e)=>{
    const target = e.target;
    // If the clicked element is not a link, exit the function
    if (!target.matches("a")) return;
    const url = target.getAttribute("href");
    if (!url.startsWith("http")) {
        e.preventDefault();
        $4829e72bb21d5fc4$export$e9f61d36381871f3({
            target: target
        });
    }
});
/**
 * Handles route changes. Updates the browser history and triggers a location change
 * @param {EventTarget} target - The link element
 */ function $4829e72bb21d5fc4$export$e9f61d36381871f3({ target: target, href: href }) {
    const newHref = href || target;
    window.history.pushState(null, "", newHref);
    $4829e72bb21d5fc4$export$658ba4b23e32bee3();
}
/**
 * Handles location changes. Matches the current path to a route and calls the route's handler
 */ async function $4829e72bb21d5fc4$export$658ba4b23e32bee3() {
    const pathName = window.location.pathname;
    const { route: currentRoute, params: params } = (0, $4672f44f88bd2bca$export$2e2bcd8739ae039)(pathName);
    const route = $4829e72bb21d5fc4$var$routes[currentRoute];
    const controller = route.handler(params);
    await controller.init();
}



(0, $67c86a85254b66ad$export$3f65cefe8380dbea)(document, "DOMContentLoaded", async ()=>{
    await (0, $4829e72bb21d5fc4$export$658ba4b23e32bee3)();
});


//# sourceMappingURL=index.81b6dee4.js.map
